const COOLDOWN_MS = 24 * 60 * 60 * 1000;

export function canRegenerateInviteCode(team) {
  if (!team?.invite_code_regenerated_at) return true;
  const elapsed = Date.now() - new Date(team.invite_code_regenerated_at).getTime();
  return elapsed >= COOLDOWN_MS;
}

export function inviteRegenerateCooldownMessage(team) {
  if (canRegenerateInviteCode(team)) return null;
  const remaining = COOLDOWN_MS - (Date.now() - new Date(team.invite_code_regenerated_at).getTime());
  const hours = Math.max(1, Math.ceil(remaining / (60 * 60 * 1000)));
  return `Invite code can only be regenerated once every 24 hours. Try again in about ${hours} hour${hours === 1 ? '' : 's'}.`;
}
